import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { uploadPhotosEntity } from "@/services/API/shared";
import { setLocalLoading } from "@/store/ui/ui";
import { RootState } from "@/store/store";
import { addingPhotos } from "@/store/patients/patients";

import { IAddingPhotos } from "@/shared/interfaces/patientPage";

export default function useDownloadPhotos() {
    const dispatch = useDispatch();
    const selectedPatient = useSelector(
        (state: RootState) => state.patients.selectedPatient,
    );
    const { _id, name } = selectedPatient;

    async function handleDownloadPfotos(data: IAddingPhotos) {
        const filesArray = data.file ? Array.from(data.file) : [];
        const surname = name.split(" ")[0];

        const formData = new FormData();
        formData.append("title", data.title);
        formData.append("description", data.description);
        formData.append("patientId", _id ? _id : "");
        formData.append("surname", surname);

        filesArray.forEach(file => {
            formData.append("photos", file);
        });
        dispatch(setLocalLoading(true));

        const response = await uploadPhotosEntity(formData);

        if (response?.status === "success" && response.data) {
            dispatch(addingPhotos(response.data));
            toast.success("Фотограції завантажені");
        } else {
            toast.error(response?.error || "Помилка при завантаженні фото");
        }

        dispatch(setLocalLoading(false));
    }
    return { handleDownloadPfotos };
}
